import React, { Component } from 'react';
import Auth from '../Auth/Auth';
class LogOut extends Component {
    constructor(props) {
        super(props);
        this.auth = new Auth();
    }

    componentDidMount() {
        this.auth.logout();
    }

    render() {
        return (
            <div></div>
        );
    }
}


export default LogOut;